import Page from '@pelckmans/elementis/components/page';
import { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useRoutes } from '../../../../hooks/useRoutes';
import ContentBody from '../../../../layout/content/ContentBody';
import { ExerciseCategoriesContext } from '../../_contexts/ExerciseCategoriesContext';
import ModuleContext from '../../_contexts/ModuleContext';
import { findExerciseCategory } from '../util';
import ExerciseCategoryCard from './ExerciseCategoryCard';
import MaterialSections from './MaterialSections';

function VirtualExerciseModuleCategoryDetail() {
  const { selectedCategoryId, subjectSlug, methodSlug } = useParams();
  const { buildAbsolutePath } = useRoutes();
  const { exerciseCategories, loading } = useContext(ExerciseCategoriesContext);
  const { module } = useContext(ModuleContext);

  const selectedCategory = findExerciseCategory(exerciseCategories, selectedCategoryId || '');

  if (!subjectSlug || !methodSlug || !module || loading) return null;

  if (!selectedCategory) {
    return (
      <Navigate
        to={buildAbsolutePath(['MATERIAL', 'MATERIAL.CONTENT', 'MATERIAL.VEM'], {
          subjectSlug: subjectSlug,
          methodSlug: methodSlug,
          moduleSlug: module.slug,
        })}
      />
    );
  }

  if (selectedCategory && !selectedCategory[selectedCategory.length - 1].categories) {
    return (
      <Page>
        <ContentBody>
          <MaterialSections />
        </ContentBody>
      </Page>
    );
  }

  return (
    <Page>
      <ContentBody>
        <div className="vem">
          <section className="list-cards">
            {selectedCategory[selectedCategory.length - 1].categories!.map(exerciseCategory => (
              <ExerciseCategoryCard key={exerciseCategory.id} exerciseCategory={exerciseCategory} />
            ))}
          </section>
        </div>
      </ContentBody>
    </Page>
  );
}

export default VirtualExerciseModuleCategoryDetail;
